import { FC, useContext } from "react";
import { sortLiveTopLeagues } from "@finbackoffice/fe-core";
import { FavoriteEventsContext, FeedContext } from "@finbackoffice/site-core";
import styles from "../categories/live-categories.module.sass";
import LiveTournament from "../../tournament/LiveTournament";

const LiveTopLeagues: FC = () => {
    const { liveTopLeagues } = useContext(FeedContext);
    const { favLiveLeagues } = useContext(FavoriteEventsContext);

    if (Boolean(!liveTopLeagues.length) && Boolean(!favLiveLeagues.length)) return null;

    return (
        <div className={styles.categoryItemsList}>
            <div>
                {[...favLiveLeagues, ...liveTopLeagues]
                    .sort(sortLiveTopLeagues)
                    .map((tournament) => (
                        <LiveTournament
                            key={tournament.id}
                            tournament={tournament}
                            sportId={tournament.sport_id}
                            eventIds={!tournament.is_top ? tournament.events : undefined}
                        />
                    ))}
            </div>
        </div>
    );
};

export default LiveTopLeagues;
